import { FLOURISH_ROUTES } from '~/src/constants/flourish'
import type { Common } from '~/src/types/app'

export const isFlourishUrl = (url: string): boolean =>
  FLOURISH_ROUTES.some((route) => url.startsWith(route))

export const resizeFlourishIframe = (iframeElement: HTMLIFrameElement) => {
  const resizeListener = (event: Common) => {
    if (!isFlourishUrl(event.origin)) return
    if (event.source !== iframeElement.contentWindow) return

    const data = JSON.parse(event.data)

    if (data?.context !== 'iframe.resize') return

    const height = data?.height + 20
    iframeElement.style.height = `${height}px`
  }

  window.addEventListener('message', resizeListener)

  return () => window.removeEventListener('message', resizeListener)
}

export function hasFlourishFullscreen(htmlString: string): boolean {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, 'text/html')

  const fullscreenDiv = doc.querySelector(
    'div[data-flourish-fullscreen="true"]',
  )

  return fullscreenDiv !== null
}
